import React, { ChangeEvent, FormEvent } from 'react';
import { Typography, makeStyles, TextField, Grid, Button, InputLabel, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  gutterBottom: {
    marginBottom: '1em',
  },
  inputContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '1.5em 0 3.5em',
    '& div:not(:last-child)': {
      marginRight: '1em',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '1.5em 0 2em',
    },
  },
  textFieldContainer: {
    width: '100%',
  },
  continueButton: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}));

interface DateOfBirthScreenProps {
  input: string;
  updateInput: (name: string) => void;
  handleSubmit: (event: FormEvent<HTMLFormElement>) => void;
  isMemberFlow: boolean;
}

export default function DateOfBirthScreen({ input, updateInput, handleSubmit, isMemberFlow }: DateOfBirthScreenProps) {
  const classes = useStyles();

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    updateInput(event.target.value);
  };

  return (
    <>
      <Typography variant="h5" className={classes.gutterBottom}>
        Join a Room
      </Typography>
      <Typography variant="body1">
        {isMemberFlow
          ? 'Enter your date of birth in year-month-day format for verification.'
          : "Enter the patient's date of birth in year-month-day format for verification."}
      </Typography>
      <form onSubmit={handleSubmit}>
        <div className={classes.inputContainer}>
          <div className={classes.textFieldContainer}>
            <InputLabel shrink htmlFor="input-room-name">
              Date of Birth
            </InputLabel>
            <TextField
              autoCapitalize="false"
              id="input-room-name"
              variant="outlined"
              fullWidth
              size="small"
              value={input}
              onChange={handleInputChange}
              placeholder="yyyy-mm-dd"
              helperText="Example: 2000-03-31"
              inputProps={{
                inputMode: 'numeric',
                pattern: '\\d{4}-\\d{2}-\\d{2}',
                title: 'Use yyyy-mm-dd format, for example 2000-03-31',
              }}
            />
          </div>
        </div>
        <Grid container justifyContent="flex-end">
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disabled={!input}
            className={classes.continueButton}
          >
            Continue
          </Button>
        </Grid>
      </form>
    </>
  );
}
